export type DownloadRequirementsSheetRequest = {
  pjtId: string;
};
